module.exports = __webpack_public_path__ + "img/orange.efc86dac.svg";